import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { routePath } from 'app/services/helpers'
import axios from 'app/services/http/axios';

// -------

import {Actions} from './slice';
import { Api } from 'modules/Admin/Inventory'

// -------

function* getCategory({payload: {id}}) {
  try {
    const route = routePath(Api.category, { id })

    const response = yield call(axios.get, route);
    yield put(Actions.getCategorySuccess(response));

  } catch (e) {
    return yield put(Actions.getCategoryFailed(e));
  }
}

function* save({ payload: {id, values} }) {

  console.log('id', id)
  console.log('values', values)

  try {

    if ( id === 0 ) id = 'create'
    const route = routePath(Api.category, { id })

    const response = yield call(axios.post, route, { ...values });
    yield put(Actions.saveFormSuccess(response));

    toast.success('Category has been successfully saved')

  } catch (e) {
    return yield put(Actions.saveFormFailed(e));
  }
}

export function* watchCategoriesFormSaga() {
  yield takeLatest(Actions.getCategory.type, getCategory)
  yield takeLatest(Actions.saveForm.type, save)
}

export default watchCategoriesFormSaga
